import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { RefundAdvancePaymentFormBean } from './RefundAdvancePaymentForm.types';

export const amountSectionViewVisitor = (amount: number) => <ACCEPT>(view: {
   forPositive: () => ACCEPT;
   forNegative: () => ACCEPT;
}) => {
   if (amount >= 0) {
      return view.forPositive();
   }

   return view.forNegative();
};

export const formInitializer = (
   totalAmount: number | undefined,
   advancePayment: FinancialSettlementAdvancePayment
) => (): RefundAdvancePaymentFormBean => {
   const advancePaymentAmount = advancePayment.remainingAmount.asNumber();

   const balanceAmount = (totalAmount ?? 0) - advancePaymentAmount;

   return {
      totalAmount: totalAmount ?? 0,
      advancePaymentAmount: advancePaymentAmount,
      refundAmount: balanceAmount < 0 ? Math.abs(Number(balanceAmount.toFixed(2))) : 0,
   };
};
